export type TemplateCategory =
  | 'FULL_BODY'
  | 'TORSO_PIERNA'
  | 'EMPUJE_TRACCION_PIERNA'
  | 'PECHO'
  | 'ESPALDA'
  | 'BRAZOS'
  | 'PIERNAS'
  | 'HOMBROS'
  | 'GLUTEOS_CORE'
  | 'GENERAL_ACONDICIONAMIENTO';

export const TEMPLATE_CATEGORIES: { value: TemplateCategory; label: string }[] = [
  { value: 'FULL_BODY', label: 'Full Body' },
  { value: 'TORSO_PIERNA', label: 'Torso-Pierna' },
  { value: 'EMPUJE_TRACCION_PIERNA', label: 'Empuje-Tracción-Pierna' },
  { value: 'PECHO', label: 'Pecho' },
  { value: 'ESPALDA', label: 'Espalda' },
  { value: 'BRAZOS', label: 'Brazos' },
  { value: 'PIERNAS', label: 'Piernas' },
  { value: 'HOMBROS', label: 'Hombros' },
  { value: 'GLUTEOS_CORE', label: 'Glúteos / Core' },
  { value: 'GENERAL_ACONDICIONAMIENTO', label: 'General / Acondicionamiento' },
];

export function categoryLabel(category: TemplateCategory | string): string {
  return TEMPLATE_CATEGORIES.find((c) => c.value === category)?.label ?? category;
}

export const MAX_TEMPLATE_EXERCISES = 10;
